import styled from "@emotion/styled";

import { fontFredoka } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  block-size: 100%;
`;

export const CurrentQuestionNumber = styled.div`
  flex: 1;

  margin-block-end: 16px;
  padding-block-start: 24px;
  padding-inline: 24px;

  font-weight: 500;
  font-size: 12px;
  font-family: ${fontFredoka};
  line-height: 14.4px;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block-start: 32px;
    padding-inline: 32px;

    font-size: 16px;
    line-height: 19.2px;
  }
`;
